import { createSlice } from '@reduxjs/toolkit';

import { SiteRole } from 'src/features/auth';
import { ISiteState } from 'src/features/site/domain/types';

import {
	SITE_LOADING_KEY,
	getSiteDetails,
	getSites,
	updateSite,
} from './siteThunks';

const initialState: ISiteState = {
	siteDetails: null,
	siteRolesMap: {},
};

const siteSlice = createSlice({
	name: SITE_LOADING_KEY,
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getSites.fulfilled, (state, action) => {
			state.siteRolesMap = action.payload.results.reduce(
				(acc, site) => {
					if (site.slug && site.roles && site.roles.length > 0) {
						acc[site.slug] = site.roles;
					}
					return acc;
				},
				{} as Record<string, SiteRole[]>,
			);
		});
		builder.addCase(getSiteDetails.fulfilled, (state, action) => {
			state.siteDetails = action.payload;
		});
		builder.addCase(updateSite.fulfilled, (state, action) => {
			if (
				state.siteDetails &&
				state.siteDetails.slug === action.meta.arg.siteSlug
			) {
				state.siteDetails = {
					...state.siteDetails,
					...action.payload,
				};
			}
		});
	},
});

export default siteSlice.reducer;
